import {
  CButton,
  CCol,
  CDataTable,
  CCardHeader,
  CInput,
  CLabel,
  CRow,
} from "@coreui/react";
import React, { useCallback, useEffect, useState } from "react";
import { apiCall, apiCallResponse, downloadUrl } from "src/_apiConfig/apiCall";
import Auth from "src/auth";
import { CommonSearch, updateSearchStatus } from "../common/CommonSearch";
import {
  FilterEqual,
  FilterContainsInsensitive,
} from "../common/FilterCondition";
//import { TableHeader } from "../common/TableHeaderLabel";
import { useParams } from "react-router-dom";
import { TableHeader } from "../common/Table/TableHeaderLabel";
import CustomeModalPopup from "../common/CustomeModalPopup";

const Lotlist = () => {
  const { type } = useParams();

  const [usersData, setUsersData] = useState();
  const [pageCount, setPageCount] = useState(0); // List Data pagging manage
  const [loading, setloading] = useState(false);
  const [pageLimit, setpageLimit] = useState(0);
  const [disabledprev, setdisabledprev] = useState(false);
  const [disablednext, setdisablednext] = useState(false);
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [order, setorder] = useState("asc");
  const [orderClick, setOrderClick] = useState(true);
  const [itemPerPage, setItemPerPage] = useState(10);
  const [selectData, setSelectData] = useState([]);
  const [selectedObj, setSelectedObj] = useState([]);
  const { authenticated } = Auth();
  const [textField, settextField] = useState("emailId");
  const [isPaidActualGodownRent, setisPaidActualGodownRent] = useState(false);
  const [actualbagopen, setactualbagopen] = useState(false);
  const [actualbaglotid, setactualbaglotid] = useState(false);
  const [actualbagQty, setactualbagQty] = useState(0);
  const [actualbagLotNo, setactualbagLotNo] = useState(0);
  const [actualbagGodownRent, setactualbagGodownRent] = useState(0);
  const [actualbagGodownRentTotal, setactualbagGodownRentTotal] = useState(0);
  const [IsGRPayViaLumpSumAmont, setIsGRPayViaLumpSumAmont] = useState();
  const [GodownRentLumpSumAmount, setGodownRentLumpSumAmount] = useState();

  const [isSearch, setIsSearch] = useState(false); // Search Button Effect Manage
  const [isClear, setIsClear] = useState(false); // Clear Button Effect Manage

  // if (authenticated.role === "Bidder") {
  //   let data = {
  //     collectionSeason: search.collectionSeason,
  //     tenderNo: search.tenderNo,
  //     lotNo: search.lotNo,
  //   };
  //   localStorage.setItem("bidderLotListSearch", JSON.stringify(data));
  // }

  // Search Model Init
  const SearchFilterModel = {
    collectionSeason: new Date().getFullYear().toString(),
    tenderNo: "",
    emailAddress: "",
    lotNo: "",
    companyName: "",
  };

  // Search Model
  const [search, setSearch] = useState(SearchFilterModel);

  const [bidderLotList, setBidderLotList] = useState(null);
  // Callback to get data from localStorage
  const getLocalStorageData = useCallback(() => {
    const storedData = localStorage.getItem("bidderLotListSearch");
    if (storedData) {
      const ds = JSON.parse(storedData);
      console.log("Retrieved from localStorage:", ds);

      setBidderLotList(ds);
      setSearch({
        ...search,
        collectionSeason: ds.collectionSeason,
        tenderNo: ds.tenderNo,
        lotNo: ds.lotNo,
      });
      let data = {
        collectionSeason: ds.collectionSeason,
        tenderNo: ds.tenderNo,
        lotNo: ds.lotNo,
      };
      localStorage.setItem("bidderLotListSearch", JSON.stringify(data));
    } else {
      console.log("No data found in localStorage");
    }
  }, []); // No dependencies -> memoized once

  useEffect(() => {
    if (authenticated.role === "Bidder") {
      getLocalStorageData();
      //setBidderLotList(JSON.parse(storedData));
    }

    setloading(true);
    reset();
    getPageCount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated, getLocalStorageData]);

  useEffect(() => {
    if (authenticated.role === "Bidder") {
      const storedData = localStorage.getItem("bidderLotListSearch");
      if (storedData) {
        console.log("dddd bidderLotList : ", bidderLotList);
        console.log("dddd search : ", search);
        if (isSearch === false) {
          const mockEvent = { preventDefault: () => {} }; // Mock event
          searchButton(mockEvent);
          // reset();
          // getPageCount();
          // getLotList();
        }
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localStorage.getItem("bidderLotListSearch")]);

  useEffect(() => {
    if (isSearch === false) {
      getLotList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated, pageLimit, textField, orderClick]);

  useEffect(() => {
    if (isSearch) {
      getPageCount();
      getLotList(true);
      setIsClear(false);
      setIsSearch(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSearch, itemPerPage]);

  // pagging Disabled  manage
  const paggingDisabled = (isNext = true, isPrev = true) => {
    setdisablednext(isNext);
    setdisabledprev(isPrev);
  };
  // pagging Manage
  const paggingManage = (totalRecord, isRecordGet = true) => {
    if (isRecordGet === false) {
      setPageCount(0);
      paggingDisabled();
    } else {
      setPageCount(parseInt(totalRecord));
      paggingDisabled(
        pageLimit >= parseInt(totalRecord) - parseInt(itemPerPage),
        pageLimit === 0
      );
    }
  };

  // Filter paramater Value manage for API
  const filterManage = () => {
    console.log("filter : search : ", search, bidderLotList);
    let filter = "";
    filter = "&$filter=";
    if (authenticated.role === "CFO") {
      filter += "isSelected eq true and circleId eq " + authenticated.district;
      if (type === "1") {
        filter +=
          " and isBidderAgreementLettersSigned eq true and isCCFAgreementLettersSigned eq false";
      }
    }
    if (authenticated.role === "DFO") {
      filter +=
        "isSelected eq true and districtId eq " + authenticated.district;
    }
    if (authenticated.role === "Bidder") {
      filter += "isSelected eq true and userid eq " + authenticated.district;
    }
    if (authenticated.role === "CGMF") {
      filter += "isSelected eq false and IsSanctionLetterGenerated eq false";
    }
    filter = FilterContainsInsensitive(filter, "emailId", search.emailAddress);
    filter = FilterContainsInsensitive(filter, "lotNo", search.lotNo);
    filter = FilterContainsInsensitive(
      filter,
      "companyName",
      search.companyName
    );
    filter = FilterEqual(filter, "collectionSeason", search.collectionSeason);
    filter = FilterEqual(filter, "tenderNo", search.tenderNo);

    if (filter === "&$filter=") {
      filter = "";
    }
    if (authenticated.role === "CFO" && type === "1") {
      filter = `&typeId=1` + filter;
    }

    if (authenticated.role === "Bidder") {
      let data = {
        collectionSeason: search.collectionSeason,
        tenderNo: search.tenderNo,
        lotNo: search.lotNo,
      };
      localStorage.setItem("bidderLotListSearch", JSON.stringify(data));
    }
    return filter;
  };
  const getPageCount = async () => {
    if (authenticated) {
      await apiCallResponse(`LotDetails/getLotDetails?${filterManage()}`).then(
        (res) => {
          if (res.success) paggingManage(parseInt(res.data.length) || 0);
          else paggingManage(0, false);
        }
      );
    }
  };
  const getLotList = async (firstRequest) => {
    if (authenticated) {
      paggingDisabled();
      setloading(true);

      await apiCallResponse(
        `LotDetails/getLotDetails?$orderBy=${textField}%20${order}&$skip=${pageLimit}&$top=${parseInt(
          itemPerPage
        )}${filterManage()}`
      ).then((res) => {
        if (res.success) {
          const jsonobj = res.data;
          setUsersData(jsonobj);
          setSelectedObj(jsonobj);

          let resData = [];
          for (let i = 0; i < jsonobj.length; i++) {
            resData.push(jsonobj[i].lotId);
          }

          if (resData.length > 0 && authenticated.role === "CGMF") {
            setDisableSubmit(false);
            setSelectData(resData);
          } else {
            setDisableSubmit(true);
          }
          if (isSearch === false && pageLimit >= 0 && pageCount > 0) {
            paggingManage(pageCount);
          }

          console.log("getLotList : " + disableSubmit);
        } else {
          setUsersData();
          setSelectedObj();
          setDisableSubmit(true);
          paggingManage(0, false);
        }
        setloading(false);
      });
    }
  };
  function reset() {
    setpageLimit(0);
  }

  const selectApiCall = async () => {
    console.log(selectedObj);
    if (selectedObj != null && selectedObj.length > 0) {
      setloading(true);
      const header = new Headers();
      header.append("Content-Type", "application/json");
      header.append("Accept", "application/json");
      const selectResponse = await apiCall(
        `LotDetails/MarkSelected`,
        "PUT",
        header,
        JSON.stringify(selectData)
      );

      await selectResponse.json();
      if (selectResponse.status === 200) {
        setSelectData([]);
        setSelectedObj([]);
        setloading(true);
        getLotList(true);
        // myRef.current.setFindArrResult();
      }
      setloading(false);
    } else {
      alert("Please select atleast one option");
    }
  };
  const deleteApiCall = async () => {
    if (selectedObj != null && selectedObj.length > 0) {
      const header = new Headers();
      header.append("Content-Type", "application/json");
      header.append("Accept", "application/json");
      const responseData = await apiCall(
        `LotDetails/deleteLots`,
        "DELETE",
        header,
        JSON.stringify(selectData)
      );
      await responseData.json();
      if (responseData.status === 200) {
        setSelectData([]);
        setSelectedObj([]);
        setloading(true);
        getLotList(true);
      }
    } else {
      alert("Please select atleast one option");
    }
  };
  const handleActualBagPopupOpen = (
    lotid,
    bags,
    lotno,
    godownrent,
    isGRPayViaLumpSumAmont,
    godownRentLumpSumAmount
  ) => {
    getIsGRAmountPaid(
      lotid,
      bags,
      lotno,
      godownrent,
      isGRPayViaLumpSumAmont,
      godownRentLumpSumAmount
    );
  };
  const getIsGRAmountPaid = async (
    lotid,
    bags,
    lotno,
    godownrent,
    isGRPayViaLumpSumAmont,
    godownRentLumpSumAmount
  ) => {
    setloading(true);
    const header = new Headers();
    const response = await apiCall(
      `LotDetails/IsPaidGodownRent?lotid=${Number(lotid)}`,
      "GET",
      header,
      null
    );
    const jsonobj = await response.json();
    if (response.status === 200) {
      setisPaidActualGodownRent(jsonobj);
      setactualbagopen(true);
      setactualbagQty(bags);
      setactualbaglotid(lotid);
      setactualbagLotNo(lotno);
      setactualbagGodownRent(godownrent);
      setIsGRPayViaLumpSumAmont(
        isGRPayViaLumpSumAmont === null ? false : isGRPayViaLumpSumAmont
      );
      setGodownRentLumpSumAmount(godownRentLumpSumAmount);

      let total = godownrent * bags;
      setactualbagGodownRentTotal(total);
    }
    setloading(false);
  };
  const handleActualBagClose = () => setactualbagopen(false);

  const calculateTotalRent = (qty) => {
    setactualbagQty(qty);
    let total = actualbagGodownRent * qty;
    setactualbagGodownRentTotal(total);
  };
  const addActualBags = async (lotid, bags) => {
    setloading(true);

    const header = new Headers();
    const response = await apiCall(
      `LotDetails/AddActualBags?lotid=${lotid}&bags=${bags}&grrent=${GodownRentLumpSumAmount}&isgrpayvialumpsumamt=${IsGRPayViaLumpSumAmont}`,
      "GET",
      header,
      null
    );
    await response.json();
    if (response.status === 200) {
      setloading(false);
      // setpageLimit(0);
      // setIsSearch(true);
      window.location.reload();
    }
  };
  //table header Click manage
  const thClick = (ev, getTextField) => {
    ev.preventDefault();
    setOrderClick(!orderClick);
    if (textField !== getTextField) {
      setorder("asc");
    } else {
      !orderClick ? setorder("asc") : setorder("desc");
    }
    reset();
    settextField(getTextField);
  };
  //table Header Set
  const TableHeaderSet = (labelValue, getTextField) => {
    return TableHeader(labelValue, getTextField, thClick, textField, order);
  };
  // Search Model Value Update Manage
  const updateSearch = (e, name = "", value = "") => {
    updateSearchStatus(setSearch, search, e, name, value);
  };

  // item per page  onChanage Event
  const onChangePage = (ev) => {
    ev.preventDefault();
    setpageLimit(0);
    setItemPerPage(ev.target.value);
    setIsSearch(true);
  };

  // Search Button Click Event
  const searchButton = (ev) => {
    ev.preventDefault();
    reset();
    setIsSearch(true);
  };
  // Clear Button Click Event
  const clearSearch = (ev) => {
    ev.preventDefault();
    reset();
    setIsClear(true);
    setIsSearch(true);

    setSearch({ ...search, ...SearchFilterModel });

    setUsersData();

    localStorage.removeItem("bidderLotListSearch");
  };

  // Pagging Prev. Button Click Event
  const prevButton = () => {
    let pageLimitCheck = pageLimit - parseInt(itemPerPage);
    if (pageLimitCheck < 0) {
      pageLimitCheck = 0;
    }
    setpageLimit(pageLimitCheck);
  };
  // Pagging Next Button Click Event
  const nextButton = () => {
    let pageLimitCheck = pageLimit + parseInt(itemPerPage);
    if (pageLimitCheck >= parseInt(pageCount)) {
      pageLimitCheck = parseInt(pageCount);
      setdisablednext(true);
    }
    setpageLimit(pageLimitCheck);
  };
  let fields = [];
  if (authenticated.role === "CGMF") {
    fields = [
      {
        key: "ShowCheckBox",
        label: "Select",
        sorter: false,
        filter: false,
      },
      {
        key: "emailId",
        label: TableHeaderSet("Email Address", "emailId"),
      },
      {
        key: "companyName",
        label: TableHeaderSet("Company Name", "companyName"),
      },
      {
        key: "lotNo",
        label: TableHeaderSet("Lot Number", "lotNo"),
      },
      {
        key: "tenderNo",
        label: TableHeaderSet("Tender", "tenderNo"),
      },
      {
        key: "quantity",
        label: TableHeaderSet("Quantity", "quantity"),
      },
      {
        key: "actualbags",
        label: TableHeaderSet("Actual Bags", "actualbags"),
      },
      {
        key: "godownrent",
        label: TableHeaderSet("Godown Rent", "godownrent"),
      },
      {
        key: "purchaseRate",
        label: TableHeaderSet("Purchase Rate per S.B.", "purchaseRate"),
      },
      {
        key: "purchasePrice",
        label: TableHeaderSet("Purchase Price (In Rs.)", "purchasePrice"),
      },
      {
        key: "show_details",
        label: "View",
        _style: { width: "1%" },
        sorter: false,
        filter: false,
      },
    ];
  } else if (authenticated.role === "Bidder") {
    fields = [
      {
        key: "lotNo",
        label: TableHeaderSet("Lot number", "lotNo"),
      },
      {
        key: "tenderNo",
        label: TableHeaderSet("Tender", "tenderNo"),
      },
      {
        key: "socity",
        label: TableHeaderSet("Society", "socity"),
        //label: TableHeaderSet("Quantity", "quantity"),
      },
      {
        key: "quantity",
        label: TableHeaderSet("Estimated Quantity", "quantity"),
        //label: TableHeaderSet("Quantity", "quantity"),
      },

      {
        key: "actualQuantity",
        label: TableHeaderSet("Actual Quantity", "actualQuantity"),
        //label: TableHeaderSet("Quantity", "quantity"),
      },
      {
        key: "godownQuantity",
        label: TableHeaderSet("Godown Quantity", "godownQuantity"),
        //label: TableHeaderSet("Quantity", "quantity"),
      },

      // {
      //   key: "actualbags",
      //   label: TableHeaderSet("Actual Bags", "actualbags"),
      // },
      // {
      //   key: "godownrent",
      //   label: TableHeaderSet("Godown Rent", "godownrent"),
      // },
      {
        key: "purchaseRate",
        label: TableHeaderSet("Purchase Rate per S.B.", "purchaseRate"),
      },
      {
        key: "purchasePrice",
        label: TableHeaderSet("Purchase Price (In Rs.)", "purchasePrice"),
      },
      {
        key: "emdAmount",
        label: TableHeaderSet("EMD Amount (10%)", "emdAmount"),
        //label: TableHeaderSet("Quantity", "quantity"),
      },
      {
        key: "addAmount",
        label: TableHeaderSet("EMD Amount (15%)", "addAmount"),
        //label: TableHeaderSet("Quantity", "quantity"),
      },
      {
        key: "show_details",
        label: "View",
        _style: { width: "1%" },
        sorter: false,
        filter: false,
      },
      {
        key: "viewTermiationLetter",
        label: "View Termination Letter",
        _style: { width: "3%" },
        sorter: false,
        filter: false,
      },
    ];
  } else {
    fields = [
      {
        key: "emailId",
        label: TableHeaderSet("Email Address", "emailId"),
      },
      {
        key: "companyName",
        label: TableHeaderSet("Company Name", "companyName"),
      },
      {
        key: "lotNo",
        label: TableHeaderSet("Lot Number", "lotNo"),
      },
      {
        key: "tenderNo",
        label: TableHeaderSet("Tender", "tenderNo"),
      },
      {
        key: "quantity",
        label: TableHeaderSet("Quantity", "quantity"),
      },
      {
        key: "actualbags",
        label: TableHeaderSet("Actual Bags", "actualbags"),
      },
      {
        key: "godownrent",
        label: TableHeaderSet("Godown Rent", "godownrent"),
      },
      {
        key: "purchaseRate",
        label: TableHeaderSet("Purchase Rate per S.B.", "purchaseRate"),
      },
      {
        key: "purchasePrice",
        label: TableHeaderSet("Purchase Price (In Rs.)", "purchasePrice"),
      },
      {
        key: "show_details",
        label: "View",
        _style: { width: "1%" },
        sorter: false,
        filter: false,
      },
      {
        key: "viewSanctionLetter",
        label: "View Sanction",
        _style: { width: "1%" },
        sorter: false,
        filter: false,
      },

      {
        key: "viewTermiationLetter",
        label: "View Termination Letter",
        _style: { width: "1%" },
        sorter: false,
        filter: false,
      },
    ];

    if (authenticated.role === "DFO") {
      fields.push({
        key: "AddActualBag",
        label: "Add Actual Bag / LumpSum Godown Rent Amount",
        sorter: false,
        filter: false,
      });
    }
  }

  const FilterBind = (role, type) => {
    if (role === "CGMF" || role === "CFO" || role === "DFO") {
      return true;
    } else if (role === "Bidder") {
      return false;
    }
  };

  const HeaderBind = (role) => {
    if (role === "CGMF") {
      return "Lot Selection";
    } else if (role === "CFO" || role === "DFO" || role === "Bidder") {
      return "Lot List";
    }
  };
  const CompanyNameLabel = (role) => {
    if (role === "CGMF" || role === "CFO" || role === "DFO") {
      return "";
    } else if (role === "Bidder") {
      return "";
    }
  };

  const addActualBagSubmit = () => {
    handleActualBagClose();
    addActualBags(actualbaglotid, actualbagQty);
  };
  return (
    <CCardHeader className="mb-3 shadow-sm">
      <CRow xl={12} className="mt-2">
        <CCol xl={10}>
          <h3>{HeaderBind(authenticated.role)}</h3>
        </CCol>
      </CRow>
      <hr />
      <CommonSearch
        isDisabledSearchClear={loading}
        isClear={isClear}
        search={search}
        updateSearch={updateSearch}
        searchButton={searchButton}
        clearSearch={clearSearch}
        itemPerPage={itemPerPage}
        onChangePage={onChangePage}
        isDisabledExport={usersData && usersData.length > 0 ? false : true}
        isCompanyNameDisplay={FilterBind(authenticated.role, "CompanyName")}
        isEmailAddressDisplay={FilterBind(authenticated.role, "EmailAddress")}
        CompanyNameLabel={CompanyNameLabel(authenticated.role)}
        isLotNumberDisplay={true}
      />

      <CRow className="mt-3 ">
        <CCol xl={12}>
          <CDataTable
            fields={fields}
            items={usersData}
            responsive
            border
            id="lotId"
            loading={loading}
            scopedSlots={{
              ShowCheckBox: (lotItm, index) => {
                //
                var findArrResult = selectData.find(
                  (data) => lotItm["lotId"] === data
                );
                const checkedFun = () => {
                  //
                  let idArr = selectData;
                  let idObj = selectedObj;
                  let findResult = selectData.find(
                    (data) => lotItm["lotId"] === data
                  );
                  if (findResult) {
                    idArr = idArr.filter((data) => lotItm["lotId"] !== data);
                    setSelectData(idArr);
                    idObj = idObj.filter(
                      (data) => lotItm["lotId"] !== data.lotId
                    );
                    setSelectedObj(idObj);
                  } else {
                    idArr.push(lotItm["lotId"]);
                    idObj.push(lotItm);
                    setSelectData(idArr);
                    setSelectedObj(idObj);
                  }
                  if (selectData.length > 0) {
                    setDisableSubmit(false);
                  } else {
                    setDisableSubmit(true);
                  }
                };
                return (
                  <td className="py-2">
                    <input
                      type="checkbox"
                      checked={findArrResult}
                      onChange={checkedFun}
                    />
                  </td>
                );
              },
              show_details: (item, index) => {
                let id;
                id = window.btoa(item.lotId);

                return (
                  <td className="py-2">
                    <CButton
                      variant="outline"
                      shape="square"
                      size="sm"
                      to={"/lotlistview/" + id}
                      color="success"
                    >
                      View
                    </CButton>
                  </td>
                );
              },
              viewSanctionLetter: (item, index) => {
                return (
                  <td className="py-2">
                    {item.sanctionLetterPath !== "" ? (
                      <a
                        href={`${downloadUrl}/${item.sanctionLetterPath}`}
                        target="_blank"
                        className="ml-2"
                        rel="noreferrer"
                      >
                        <CButton
                          variant="outline"
                          shape="square"
                          size="sm"
                          color="success"
                        >
                          View Sanction Letter
                        </CButton>
                      </a>
                    ) : (
                      ""
                    )}
                  </td>
                );
              },
              AddActualBag: (item, index) => {
                return (
                  <td className="py-2" style={{ textAlign: "center" }}>
                    <CButton
                      variant="outline"
                      shape="square"
                      size="md"
                      color="success"
                      hidden={item.tenderType === 1 ? false : true}
                      onClick={() =>
                        handleActualBagPopupOpen(
                          item.lotId,
                          item.actualbags,
                          item.lotNo,
                          item.godownrent,
                          item.isGRPayViaLumpSumAmont,
                          item.godownRentLumpSumAmount
                        )
                      }
                    >
                      Add
                    </CButton>
                    <div>
                      <>
                        <CustomeModalPopup
                          onOpen={actualbagopen}
                          onClose={handleActualBagClose}
                          onSubmitButton={addActualBagSubmit}
                          onCloseButton={handleActualBagClose}
                          popupWith={450}
                          body={
                            <>
                              <CRow>
                                <CCol>
                                  <CLabel>Lot No:</CLabel>
                                  <CLabel className="ml-2">
                                    {actualbagLotNo}{" "}
                                  </CLabel>
                                </CCol>
                                <CCol>
                                  <CLabel>Godown Rent:</CLabel>
                                  <CLabel className="ml-2">
                                    {actualbagGodownRent}{" "}
                                  </CLabel>
                                </CCol>
                              </CRow>
                              <hr />
                              <CRow>
                                <CCol className="mt-2">
                                  <input
                                    id="rdbActualBags"
                                    placeholder=""
                                    name="godownrentoption"
                                    type="radio"
                                    style={{ marginRight: "10px" }}
                                    checked={
                                      IsGRPayViaLumpSumAmont === false ||
                                      IsGRPayViaLumpSumAmont === null
                                        ? true
                                        : false
                                    }
                                    onChange={(e) => {
                                      setIsGRPayViaLumpSumAmont(
                                        e.target.checked === true ? false : true
                                      );
                                    }}
                                  ></input>
                                  <label for="age1">Add Actual Bags</label>

                                  <input
                                    id="rdbRentAmount"
                                    placeholder=""
                                    name="godownrentoption"
                                    type="radio"
                                    style={{
                                      marginRight: "10px",
                                      marginLeft: "30px",
                                    }}
                                    checked={
                                      IsGRPayViaLumpSumAmont !== null &&
                                      IsGRPayViaLumpSumAmont === true
                                        ? true
                                        : false
                                    }
                                    onChange={(e) => {
                                      setIsGRPayViaLumpSumAmont(
                                        e.target.checked
                                      );
                                    }}
                                  ></input>
                                  <label for="age1">
                                    Add Godown Rent Amount
                                  </label>
                                  <br></br>
                                </CCol>
                              </CRow>
                              {IsGRPayViaLumpSumAmont !== null &&
                              IsGRPayViaLumpSumAmont === false ? (
                                <>
                                  <CRow>
                                    <CCol className="mt-2">
                                      <CLabel>Actual Bags:</CLabel>
                                      <CInput
                                        type="text"
                                        value={actualbagQty}
                                        onChange={(e) =>
                                          !e.target.value ||
                                          e.target.value.match(
                                            /^\d{1,}(\.\d{0,2})?$/
                                          )
                                            ? calculateTotalRent(e.target.value)
                                            : ""
                                        }
                                        required={
                                          IsGRPayViaLumpSumAmont === false &&
                                          actualbagQty === ""
                                            ? true
                                            : false
                                        }
                                      />
                                    </CCol>
                                  </CRow>
                                  <CRow>
                                    <CCol>
                                      <CLabel>Total Rent:</CLabel>
                                      <CLabel className="ml-2 mt-2">
                                        {actualbagGodownRentTotal}{" "}
                                      </CLabel>
                                    </CCol>
                                  </CRow>
                                </>
                              ) : IsGRPayViaLumpSumAmont !== null &&
                                IsGRPayViaLumpSumAmont === true ? (
                                <CRow>
                                  <CCol className="mt-2">
                                    <CLabel>Godown Rent :</CLabel>
                                    <CInput
                                      type="text"
                                      value={GodownRentLumpSumAmount}
                                      onChange={(e) => {
                                        if (
                                          e.target.value.match(
                                            /^\d{1,}(\.\d{0,2})?$/
                                          )
                                        ) {
                                          console.log("abc: " + e.target.value);
                                          setGodownRentLumpSumAmount(
                                            e.target.value
                                          );
                                        }
                                      }}
                                      required={
                                        IsGRPayViaLumpSumAmont === true &&
                                        GodownRentLumpSumAmount === ""
                                          ? true
                                          : false
                                      }
                                    />
                                  </CCol>
                                </CRow>
                              ) : (
                                ""
                              )}
                            </>
                          }
                          isFromSubmit={true}
                          isSubmitBtnDisabled={true}
                          ButtonLoader={false}
                          disabledBtn={isPaidActualGodownRent}
                          btnSubmitText={"Add"}
                          btnCloseText={"Close"}
                        />
                      </>
                    </div>
                  </td>
                );
              },
              viewTermiationLetter: (item, index) => {
                return (
                  <td className="py-2">
                    {item.terminationLetterPath !== "" ? (
                      <a
                        href={`${downloadUrl}/${item.terminationLetterPath}`}
                        target="_blank"
                        className="ml-2"
                        rel="noreferrer"
                      >
                        <CButton
                          variant="outline"
                          shape="square"
                          size="sm"
                          color="success"
                        >
                          View Termination Letter
                        </CButton>
                      </a>
                    ) : (
                      ""
                    )}
                  </td>
                );
              },
              ShowSpan: (item, index) => {
                if (item.status === "Success")
                  return (
                    <td>
                      <span className="customGreenFont">Success</span>
                    </td>
                  );
                if (item.status !== "Success")
                  return (
                    <td>
                      <span className="customRedFont">{item.status}</span>
                    </td>
                  );
              },
              LotNumber: (item, index) => {
                return (
                  <td className="py-2">
                    <span>{item.lotNo === null ? "" : item.lotNo}</span>
                  </td>
                );
              },
            }}
          />
        </CCol>
      </CRow>

      <div className="">
        {!disableSubmit && !loading ? (
          <div>
            <CButton
              className=" offset-0 "
              color="success"
              onClick={() => selectApiCall()}
            >
              Confirm Selected
            </CButton>
            <span className="ml-2"></span>
            <CButton
              className="offset-1 ml-0"
              color="danger"
              onClick={() => deleteApiCall()}
            >
              Remove Selected
            </CButton>
          </div>
        ) : (
          ""
        )}
        <CRow className="float-right mb-3 mr-3 mt-3">
          <CButton
            className="mb-3 mr-2"
            color="success"
            onClick={prevButton}
            disabled={disabledprev}
            style={{ visibility: disabledprev ? "hidden" : "visible" }}
          >
            Prev
          </CButton>
          <CButton
            className="mb-3 "
            color="success"
            onClick={nextButton}
            disabled={disablednext}
            style={{ visibility: disablednext ? "hidden" : "visible" }}
          >
            Next
          </CButton>
        </CRow>
      </div>
    </CCardHeader>
  );
};
export default Lotlist;
